import { FC } from 'react';
import compose from '../../../utils/components/_compose';
import injectAnalyticsScope from '../../../hocs/analytics/injectAnalyticsScope';

import Step, { StepProps, StepStatics } from './Step';

const ComposedStep = compose<FC<StepProps> & StepStatics>(
  injectAnalyticsScope<StepProps>({
    key: ({ name }) => name,
    skip: ({ name }) => !name,
  }),
)(Step);

ComposedStep.type = Step.type;

export * from './Step';
export default ComposedStep;
